export default "__VITE_ASSET__Cczu3zqn__"